export default __webpack_public_path__ + "static/0119-e894a58ab09ba69fdbd852a97f3586ff.png";